import './HeatControl.css';

function SrvHeatControl() {
  return (
    <div className="overview-container">
      <div className="heat-section-title">동파방지열선 제어판넬 [TAC-1000]</div>

      <div className="heat-box">
        <b>범용으로 사용되고 있는 동파방지 열선 판넬입니다. 열선의 용량, 거리, 회로수, 외함재질에 따라 주문제작됩니다.</b><br /><br />
        (제품구성 : 박스본체, 온도센서[pt100Ω], 사용설명서)
      </div>

      <div className="heat-images">
        <img src="/images/heatcon.PNG" alt="heatcon" />
        <img src="/images/heatcon1.png" alt="heatcon1" />
      </div>

      <div className="heat-box">
        <b>▣ TAC-1000N2 ▶</b> 2회로(STEEL) : 300×400×200<br />
        <b>▣ TAC-1000N3 ▶</b> 3회로(STEEL) : 400×500×200<br />
        <b>▣ TAC-1000N4 ▶</b> 4회로(STEEL) : 400×500×200<br />
        <b>▣ TAC-1000N5 ▶</b> 5회로(STEEL) : 400×600×200<br />
        <b>▣ TAC-1000N6 ▶</b> 6회로(STEEL) : 400×600×200<br />
        <b>▣ TAC-1000S2 ▶</b> 2회로(SUS) : 300×400×200<br />
        <b>▣ TAC-1000S3 ▶</b> 3회로(SUS) : 400×500×200<br />
        <b>▣ TAC-1000A2 ▶</b> 2회로(옥외형-SUS 이중) : 400×500×280 - 지주(100mm)<br />
        <b>▣ TAC-1000A3 ▶</b> 3회로(옥외형-SUS 이중) : 400×500×280 - 지주(100mm)<br />
        <b>▣ 다수온도제어 ▶</b> 센서=온도계 수량 동일<br />
        <b>▣ 다중온도제어 ▶</b> 센서 2~8개 : 온도계 1개로 제어
      </div>

      <div className="heat-section-title">열선 설치 방법 안내</div>

      <div className="heat-box">
        <p>① 배관에 열선을 포설한 후, 종단에는 앤드실을 처리 (본드타입 수축튜브 사용)<br />
          ※ 절대 종단 2선을 합선시키지 마십시오 (화재 위험)</p>
        <p>② 시작점에 파워킷트를 고정하고 내부 터미널 하부에 열선을 연결합니다.</p>
        <div className="heat-images">
          <img src="/images/powerkit1.JPG" alt="powerkit1" />
          <img src="/images/powerkit2.JPG" alt="powerkit2" />
        </div>
        <p>(판매중)</p>
        <p>③ 터미널 상부에 전선을 연결하여 판넬까지 포설</p>
        <p>④ 온도센서는 배관 열선 반대면, 가장 추운 위치에 설치</p>
        <p>⑤ 보온재로 보온</p>
        <p>⑥ 온도센서 → 판넬까지 포설</p>
        <p className="heat-warning">
          ※※※ 정온전선은 SRF 16-2CR 동급 제품 사용, 최대 길이 150M 초과 금지 ※※※
        </p>
      </div>
    </div>
  );
}

export default SrvHeatControl;
